import { render, staticRenderFns } from "./DispenseDocuments.vue?vue&type=template&id=07aab8da"
import script from "./DispenseDocuments.vue?vue&type=script&lang=js"
export * from "./DispenseDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aab8da')) {
      api.createRecord('07aab8da', component.options)
    } else {
      api.reload('07aab8da', component.options)
    }
    module.hot.accept("./DispenseDocuments.vue?vue&type=template&id=07aab8da", function () {
      api.rerender('07aab8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/dipensation-request/components/DispenseDocuments.vue"
export default component.exports